<template>
  <div id="user-view">
    <h1>Producst</h1>
  </div>
</template>

<script>
export default {
  name: "Products",

  data() {
    return {
      user: this.$route.meta.user
    };
  },
  mounted() {
    //console.log(this.user)
    //this.user = this.$route.meta.user
  },
  methods: {}
};
</script>

<style scoped>
</style>